import { State } from './ui.reducer';
import { createSelector } from '@ngrx/store';

const _getEnabledPriorities = (state: State) => state.enabledPriorities;
const _getCustomerFilter = (state: State) => state.customerFilter;
const _getSearchText = (state: State) => state.searchText;
const _getLoginMethod = (state: State) => state.loginMethod;

export const getUiState = (appState: { ui: State }) => appState.ui;

export const getEnabledPriorities = createSelector(getUiState, _getEnabledPriorities);
export const getCustomerFilter = createSelector(getUiState, _getCustomerFilter);
export const getSearchText = createSelector(getUiState, _getSearchText);
export const getLoginMethod = createSelector(getUiState, _getLoginMethod);
